import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import { TopPage } from "./TopPage";
import { PurchasedForm } from "./PurchasedForm";
import { FAQ } from "./FAQ";
import { Agreement } from "./Agreement";
import { PickupInstructions } from "./PickupInstructions";

export const Router: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<TopPage />} />
      <Route path="/pickup_instructions" element={<PickupInstructions />} />
      <Route path="/purchased_form" element={<PurchasedForm />} />
      <Route path="/agreement" element={<Agreement />} />
      <Route path="/faq" element={<FAQ />} />
    </Routes>
  );
};
